import React, { createContext, useMemo, useState } from 'react';
import { FCWithChildren } from '../../../App.types';
import { getSongCollections, usePaginatedFetch, UsePaginatedFetchResult } from '@round/api';
import useAbortableEffect from '../../../Hooks/useAbortableEffect';

type SongCollectionsListContextValues = {
    utils: UsePaginatedFetchResult<typeof getSongCollections>;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    page: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
};

export const SongCollectionsListContext = createContext<SongCollectionsListContextValues | null>(null);
export const SongCollectionsListContextProvider: FCWithChildren = ({ children }) => {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);

    const utils = usePaginatedFetch(getSongCollections, { search, page, page_size: 10 });

    useAbortableEffect(
        (signal) => {
            utils.getCurrentPage({ signal });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [utils.getCurrentPage]
    );

    const values: SongCollectionsListContextValues = useMemo(
        () => ({ utils, page, setPage, search, setSearch }),
        [page, search, utils]
    );

    return <SongCollectionsListContext.Provider value={values}>{children}</SongCollectionsListContext.Provider>;
};
